<template>
  <div class="newsDetail">
    <div class="headImg">
      <img :src="`http://www.china-tillage.com:8000${headImg}`" alt=""  style="width:100%;"/>
    </div>
    <div class="content" v-html="content">
      新闻详情
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { baseURL } from "../../../config.ts"

export default {
  name: 'newsDetail',
  data() {
    return {
      content: "",
      hostName: "",
      headImg:"",
    }
  },
  mounted() {
    this.getheadImg()
    // console.log(hostName)
    this.$http.get(`${baseURL}/json/one?id=${this.$route.query.id}`).then((res)=>{
      // console.log(res,"123")
      // 部署后，图片访问不需要拼IP，访问服务器静态资源
      // this.content = res.data.content
      // .replace(/src="/g,`src="${baseURL}`)
      this.content = res.data.content
    })
  },
  methods: {
    // 获取大图
    getheadImg(){
      this.$http.get(`${baseURL}/json/img/new`).then( (res)=>{
          // console.log(res,"头部图片")
          this.headImg = res.data.pic
        }
      ).catch((err)=>{
        console.log(err)
      })
    },
  },
  components: {}
}
</script>

<style lang="scss" scope>
* {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.newsDetail{
  .headImg {
    width: 100%;
    // height: 656px;
    overflow: hidden;
  }
  .content{
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
  }
  // p{
  //   text-align: left;
  // }
}
</style>
